import * as s from './InfoIcon.css';

export const InfoIcon = () => <img className={s.infoIcon} src="/infoIcon.png" />;
